import React from 'react';

import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const Changelog = () => {
    useBrowserTabTitle('Changelog')

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>What's New?</h2>
                        </div>
                        
                        <div className="ibox-content">
                            <div className="row">
                                <div className="col-sm-12 m-b-xs">

                                    <h3>Version 82 Beta (2026/09/19)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>The GNC Go API is here!</strong> Connect, integrate, automate
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Add OAuth clients.</strong> Connect to third-party applications or build your own API integrations
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>API Development environment.</strong> Build and test your integrations using the new documentation and testbed environment
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>API Operations.</strong> This first release includes: List, Get and Update portfolio documents and records. More operations coming soon. Requests welcome!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Open SharePoint links in the native application.</strong> CADM Admins can now specify the default file open behaviour in CADM Admin | SharePoint Application. As requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Swap contents of location fields.</strong> Quickly populate your Live/Filed location from the Reserved location field (or vice versa) using the new Swap Contents icon
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Need help?</strong> Added to the bottom of every page to make it easier to find help or contact us
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! A new info message warns you before overwriting a SharePoint link with a New Template. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! If you try to add an existing user (email address), you are directed to their existing details. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A caching issue that could prevent correct table loading. Thanks for reporting!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 81 Beta (2026/06/13)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>SharePoint integration for Records!</strong> New Records can save SMART Templates directly to SharePoint
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Auto-populated location links.</strong> Records added as a SMART Template automatically get a SharePoint location link in GNC Go
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Withdraw all</strong> versions of a Document simultaneously. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Browser tab titles</strong> added throughout GNC Go for a better multitab experience. As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            More SharePoint features coming soon! (For QMS Documents, QA Documents, QA Records; plus drag-and-drop filing, and more …)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Quick-access icons for Reserved Records - start work on your Draft (Reserved) Records directly from the Records table
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! SMART Template checkboxes have moved above the Location fields for smoother workflow
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Some checkboxes were not showing correctly - now they are
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A caching problem for Type-Code map changes was causing slow table updates
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                  <h3>Version 80 Beta (2026/04/10)</h3>

                                  <ul className="unstyled changelog">
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>SharePoint integration is here!</strong> As requested!
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      The GNC Go - SharePoint integration creates a limited connection between GNC Go and your SharePoint sites for more efficient workflows
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>SMART Templates save straight to SharePoint.</strong> New Documents save SMART Templates directly to SharePoint
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Auto-populated location links.</strong> Documents added as a SMART Template automatically get their SharePoint location link in GNC Go
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Location control (default locations).</strong> Admin-defined default SharePoint folders for any Project, Product or Opportunity
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Advanced location control (product tree locations).</strong> Define SharePoint folders for any or all branches of your Product Tree to enable auto-filing based on Applicability [Projects and Products only]
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      SharePoint integration knowledge base and Quick Start guides for Admins
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      More SharePoint features coming soon! (For Records, QMS Documents, QA Documents, QA Records; plus drag-and-drop filing, and more …)
                                    </li>
                                    <li>
                                      <span><span className="label label-primary">IMPROVED</span></span>
                                      All Versions quick-links are now available on Customer Documents, QMS Documents and QA Documents
                                    </li>
                                    <li>
                                      <span><span className="label label-primary">IMPROVED</span></span>
                                      SMART Template indicators added to Type drop-downs for QMS Documents, QA Documents, QA Records
                                    </li>
                                    <li>
                                      <span><span className="label label-primary">IMPROVED</span></span>
                                      Original File Location now has a quick 'Add Location from previous version' option for smoother workflow. Thanks for your feedback!
                                    </li>
                                    <li>
                                      <span><span className="label label-primary">IMPROVED</span></span>
                                      Tweaked! Issue Dates have moved below Status on multiple forms for smoother workflow
                                    </li>
                                    <li>
                                      <span><span className="label label-warning">FIXED</span></span>
                                      A bug which could prevent delete on QMS document types
                                    </li>
                                  </ul>

                                  <div className="hr-line-dashed"></div>
                                  
                                  <h3>Version 79 Beta (2026/02/01)</h3>

                                  <ul className="unstyled changelog">
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Traceability is here!</strong> As Requested!
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>All Versions.</strong> Quick-links to all versions of a document within a Project or Product
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Where From.</strong> Backward trace - all direct predecessors of a document version (any project or product)
                                    </li>
                                    <li>
                                      <span><span className="label label-info">NEW</span></span>
                                      <strong>Where Used.</strong> Forward trace - all versions derived from this document version (any project or product)
                                    </li>
                                    <li>
                                      <span><span className="label label-primary">IMPROVED</span></span>
                                      Type drop-downs now indicate if there's a SMART Template available for that Type. Thanks for your feedback!
                                    </li>
                                    <li>
                                      <span><span className="label label-warning">FIXED</span></span>
                                      A table cache and display issue introduced in v78. Thanks for your feedback!
                                    </li>
                                    <li>
                                      <span><span className="label label-warning">FIXED</span></span>
                                      Downloaded file extension were not working correctly for some users. Thanks for your feedback!
                                    </li>
                                    <li>
                                      <span><span className="label label-warning">FIXED</span></span>
                                      Date sorting in tables now works again. Thanks for your feedback!
                                    </li>
                                    <li>
                                      <span><span className="label label-warning">FIXED</span></span>
                                      Various interface tidy-ups following v78 release
                                    </li>
                                  </ul>

                                  <div className="hr-line-dashed"></div>
                                  
                                    <h3>Version 78 Beta (2025/11/08)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>GNC Go v2.0 is here!</strong> Fully rebuilt on a new generation of web technology
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Optimised for speed.</strong> Speedups for page and table loading. As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Power for bigger data sets.</strong> All the power you need for large numbers of Projects, Products, Documents and Records
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Multi-page tables are here!</strong> New table-page controls at the bottom of each table help you navigate large data sets
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Guided Tours.</strong> New Users now get a quick-start tour of Home, Portfolio and Dashboard.
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 77 Beta (2024/12/14)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Find a Configured Item... can now search by Project, Product or Opportunity name. As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Users table now displays number of Active Users. As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Product Tree appearance
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            More behind the scenes maintenance and improvements in readiness for planned new features
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A navigation bug in Deliveries
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            The Product Tree text cursor now behaves itself
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 76 Beta (2024/11/09)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Very-big Product Trees are here!</strong> As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Manage your entire space- and ground- segments in a single Product Tree
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Build and use 10-level Product Trees with many top-levels (trunks)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Product Tree builder and viewer in Information
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Product Tree Applicability tools in Documents, Customer Documents, Included Documents and Records
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Product Tree Applicability filter in Reports
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Record Type now locks after first save (adds consistency, removes a potential bug)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Several small interface improvements
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 75 Beta (2024/09/05)</h3>
                                    
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>CADM Admin help guides are here!</strong> An all-new knowledge base for CADM Admins
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Help content on Configuration Schemes, Document Types, Templates, Reports, Models, Classification Levels and more - built into the CADM Admin pages
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>In-line help</strong> (small question mark icons) for quick-access topic-specific guides
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Help pill</strong> (big question mark icon in bottom corner) to access and browse all CADM Admin guides
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A bug which could block loading of help content
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 74 Beta (2024/06/29)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Portfolio Favourites view!</strong> Manage your favourites list directly from Portfolio
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Use the <strong>pinned favourites filter</strong> to focus only on your favourite portfolio items
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Related Items are here!</strong> Add relationships between any configured items in a Project or Product
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Use <strong>Related Items</strong> to show that one or many configured items are related - to build document trees, or add supporting information to an existing Document or Record
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Tracking Reports now highlight where more than one version of a Document has been selected
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 73 Beta (2024/05/18)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Customer Document Version tools are here!</strong> As Requested!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Assign Customer Document Versions using the (optional) new Version field
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Upversion and Supersede Customer Documents</strong> with a new <strong>Upversion button</strong> for Customer Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Superseded status and full <strong>status logic</strong> - GNC Go now manages status logic for Customer Documents [Filed, Superseded, Reserved, Withdrawn]
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Live-Links for Customer Documents point to the latest Version of a Customer Document, or the Reserved Version if no Filed Version exists
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Customer Document header now indicates Filed and Superseded version status
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Baseline Tracking Reports now show the progression of a Customer Document on one row, rather than showing each Version as a separate Customer Document
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                  <h3>Version 72 Beta (2024/04/06)</h3>

                                  <ul className="unstyled changelog">
                                      <li>
                                          <span><span className="label label-primary">IMPROVED</span></span>
                                          Now you can add the same Customer Document to more than one Project or Product (Customer Document references don't need to be unique)
                                      </li>
                                      <li>
                                          <span><span className="label label-primary">IMPROVED</span></span>
                                          Tweaked! Side menu and link-button layout
                                      </li>
                                      <li>
                                          <span><span className="label label-primary">IMPROVED</span></span>
                                          Behind the scenes maintenance and improvements in readiness for planned new features
                                      </li>
                                      <li>
                                          <span><span className="label label-warning">FIXED</span></span>
                                          A Status Reports bug introduced in Version 71
                                      </li>
                                  </ul>

                                <div className="hr-line-dashed"></div>
                                
                                    <h3>Version 71 Beta (2023/12/11)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Build retrospective Baselines and planned Baselines</strong> in Tracking Reports
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Now you can add items of any status (reserved, live / filed, withdrawn, superseded) into your Tracking Reports and Baselines
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Previously, items 'in use' in a Report or Delivery couldn't be deleted - now they can
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Applicability can now be changed from any status (by CADM Controller)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Performance improvements keep things snappy
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 70 Beta (2023/11/01)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>View or download Report and Delivery items</strong> with quick-access buttons (download-open), and clickable links
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Ctrl+Click (Windows) and Cmd+Click (Mac) now opens links in a new tab. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Added Copy code and Name text to Clipboard button to Project, Product and Opportunity headers
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! The find a configured item... search algorithm gets its first tune-up
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A bug causing slow saving of Report Schemes
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Report Type dropdown menu bug (click-through to checkbox below)
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 69 Beta (2023/10/16)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>SMART Reports are here!</strong> Autogenerate your configuration management reports straight to MS Word
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Use the <strong>SMART Report button</strong> to autogenerate an entire CIDL, ABCL or any other Tracking Report you define
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            A new set of SMART Template Placeholders let you add Tracking Report contents into your own Word templates
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Assign a SMART Report Template to each of your Report Schemes. Use one template for everything, or a different template for each Report Scheme
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 68 Beta (2023/08/21)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Bulk add option for Templates allows you to assign one Template to many Document Types
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Report Schemes now allow you to add the same Document Type to multiple Report Sections. Thanks for your feedback!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 67 Beta (2023/07/03)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Live-links are here!</strong> Live-links point to the latest Live version of a Document, or the Reserved version if no Live version exists. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Three new copy to clipboard icons next to Document and Record titles: Copy full Reference and Text (all), Copy permalink (all), Copy live-link (Documents, QMS Documents, QA Documents)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Serial Numbers now allow filtering on Projects and Products
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Removed confusion between labelling of Types and Names in CADM Admin areas
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Open Document and Open Record buttons are now simply Open throughout
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Removed a bug in the application of User Groups to Quality libraries
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    <h3>Version 66 Beta (2023/05/14)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Information Classification Levels are here!</strong> Assign classification level to your documents
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Use SMART Templates to add classification level and a corresponding distribution statement to your Documents, QMS Documents and QA Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Archive Portfolio items</strong> from their Information page, and view archived items in Portfolio using the new Archived filter
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Faster browsing and linking</strong>. All main tables now support right-click access to standard browser features, such as: open link in new tab, open link in new window, and copy link address. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Type-Code Map Document Type dropdowns now show remaining items only. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Multiple interface tweaks and tidy-ups
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 65 Beta (2023/04/16)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>User Groups are here!</b> For quicker, easier permissions management. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            With User Groups you can define access permissions for a whole team, quickly add new Users to the Group, or add Groups to a new Opportunity, Project or Product
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Shhhhh! Hidden behind the scenes, GNC Go has an all-new <b>Support Centre</b> To bring you guides, tours, tips and help over the coming releases
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            In this release User Admins can learn about Permissions from the question mark icons in Users and User Groups. More support content on the way!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Raised date for a New Action Item now auto-populates to today
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A bug which could prevent removal of a Model from a Product Tree if it had been used in a Report. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Resolved an issue affecting URL links (including bookmarks) to Portfolio items
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 64 Beta (2023/02/25)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Global Search is here!</b> Now you can look everywhere at once. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Find a configured item… helps you quickly filter down to locate items across any of your Portfolio and Quality libraries
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 63 Beta (2023/01/21)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! 2FA can now be enabled and disabled using setup keys as an alternative to QR codes
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Information tile added to the Dashboard for more intuitive workflow between Information and Portfolio pages
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            More workflow tune-ups!  Select Portfolio in the menu, then any item to go to its Dashboard - or use (Change) in the header to swap between Projects or Products and return to the same menu area
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Standard Product area removed from Projects - this was obsoleted by Product functionality introduced in Version 62
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've changed the URL structure used by GNC Go for Portfolio items - but your existing bookmarks and shortcuts to GNC Go pages will continue to work just fine!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Information page Convert buttons now provide an explanation when further permissions are needed
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Dashboard tile layout improved for Read Only members
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Document Included-in lists, and New Included Document Origin dropdowns now show Project and Product codes. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! File Location fields now accept 4096 characters. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Convert button no longer displays on the Opportunity Information page
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Single-select search dropdowns previously returned unwanted search results based on matches to an internally assigned ID - these are now excluded
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 62 Beta (2022/12/05)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Products are here!</strong> Dedicated to your standard Products. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Build your Product library for NRE-free COTS deliveries, or to use as building-blocks for Projects
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            View and manage your Products from the Portfolio screen
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Product Admin and Product Controller Roles</strong> to look after your new Products (these mirror the existing Project roles)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Convert Projects to Products</strong> - and back again, from the Information page
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Configuration Schemes now lock Reference Structures, Number From and Type-Code maps when in-use
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Information page now loads and saves a little faster and is more robust to intermittent internet connections. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug relating to Customer Document mandatory fields
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            File location | Open Document button now does nothing if the field is empty. Thanks for your feedback!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 61 Beta (2022/11/26)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Project Controllers are here!</b> More flexibility to build permissions around your organisation and way of working
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project Controller permissions are based on the existing Project Admin role, but without: create New, edit Name, edit Code, Delete
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project Description field allows the whole team to view your description from Information, or using the new info icons in Portfolio
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Configuration Schemes now allow you to define starting numbers for Document and Record sequential references
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Portfolio table now displays the Manager field
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Project headers now display the Project Code (before the Project Name)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Configuration Scheme layout improved for more logical flow
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 60 Beta (2022/10/23)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Pin your Favourites!</b> Now you can Pin to the Home page Favourite Projects list
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Pin directly onto the Favourites list, or from the header area of any Project page
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tooltips have been upgraded across GNC Go for a more consistent experience
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Log out has moved off the main page (but is still in the Account dropdown)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! SMART Template Placeholders Select Configured Item filter now includes QMS Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! SMART Templates now populate 2-digit Issue numbers (instead of abbreviating 01 to 1). Thanks for your Feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A bug in Report Schemes relating to saving duplicate document Types
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 59 Beta (2022/09/18)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Bigger Product Trees!</b> Now you can manage Projects with up to 12 Systems in the top-level Product Tree
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Type-Codes for QMS Documents, QA Document and QA Records can now be Archived and Restored
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            The menu area formally known as Business is now titled Quality
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            To avoid potential problems, Reference Structures are now locked for editing when in-use. (Contact <a href="mailto:support@gncgo.com">support@gncgo.com</a> if you need to change an in-use reference structure)
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            The Search... and Select Status... filters are playing nicely together again after a brief falling out
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 58 Beta (2022/07/28)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>More tools for QMS Documents!</strong> More power to your Quality Management System
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Quick-add QMS Documents from your Home screen, manage QMS Document Types and Templates in CADM Admin
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Reference Structures using only Revision for version are now fully supported
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Document Issue fields now display the full Version information - including Issue and Revision - as appropriate
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Customer Documents table now displays Customer Org Code
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Customer Org Code in Customer Documents, and Project Code in Projects and Opportunities, can now be up to 8 digits
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! In-use dropdowns now differentiate between Projects and Opportunities
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Business Records is now deprecated and fully replaced by QA Records
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            In-use dropdowns now don't show duplicates (e.g. where there are multiple versions of a Document)
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a couple of bugs which could prevent deletion of Configuration Schemes, Document Types and Record Types
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug relating to use of DocumentTypeCodeNumber or RecordTypeCodeNumber in certain Reference Structures
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 57 Beta (2022/07/16)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>QMS Documents are here!</strong> Dedicated to the top level of your Quality Management System
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            This additional level means you can now use QA Documents for version control of QMS work product (e.g. to Upissue a risk register)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            More CADM tools for QMS Documents coming soon...
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Date-pickers have been upgraded to address a time-zone bug
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 56 Beta (2022/05/22)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Documents table now displays a Shared Document icon for Documents Included in another Project
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            GNC Go nows works more smoothly across multiple tabs in a single browser
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Fork to New Document is now available to Project Members (previously only Project CADM Controllers)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! New Projects now show up in Project Portfolio without delay. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Included Document Delete confirmation dialog has added information. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Addressed two navigation issues introduced by v55 upgrades
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Resolved an issue affecting status filter memory
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 55 Beta (2022/05/15)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>GNC Go has moved!</b> (But not very far)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Your site has moved from .gnc-go.com to .gncgo.com
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            You can now contact us at support@gncgo.com
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Extensive back-end upgrades, updates and maintenance - supporting future new features
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Fork to New Document now acts like a normal New Document - so now you can change Type when forking, and nothing is saved if you hit Cancel
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            The Included Documents | Fork to New Document button is now a fork icon, to the right of the Save-Cancel button area
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Minor workflow and cosmetic improvements
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Addressed an issue which could cause laggy behaviour on Project and Document input fields. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Dashboard | Included Documents counter. Thanks for your feedback!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 54 Beta (2022/03/28)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Forked Documents are here!</strong> Now you can create a new Document from an Included Document while maintaining traceability. Thanks for your feedback!</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Fork any issue or revision of an Included Document into a Document within the same Project</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Documents now show forked-from information in their header area</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Included Documents now show a forked-to list</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Identify your <strong>Standard Products</strong> within Project Information and Project Portfolio</li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Open buttons added in the header of all (Live or Superseded) Included Documents</li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Status radio-group in Records, QA Records, and Business Records reordered for consistency with Documents</li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Layout of Project Information page updated to bring Sharing and Standard Product areas together</li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    <h3>Version 53 Beta (2022/02/28)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Add Included Documents to Serial Numbers and Meetings
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Sharing Projects now list which Projects they’re Sharing Documents with
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Shared Documents now list which Projects they’re Included in
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Included Documents now show which Project they’re Shared from (owned by)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Add Another allows you to quickly add multiple Included Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            File Location default (URL link, or local Filepath) is now a system-level configuration option
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Included Document and New Included Document forms get minor tweaks to content loading, display and information
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Project User Access tooltips
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Project Dashboards now load more smoothly
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Reference Documents (Serial Numbers) and Supporting Documents (Meetings) lists now prevent duplicate entries
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Copy Filepath to Clipboard from main tables now copies correctly. Thanks for your feedback!
                                        </li>
                                    </ul>
                                    
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 52 Beta (2022/02/12)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Included Documents are here!</b></li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Now you can <b>share Documents between Projects</b></li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Manage modified-standard, built-to-print, and modular-design Projects by including Documents from other Projects in your configuration baseline</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Add Included Documents to Status Reports, Tracking Reports and Deliveries</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Share Documents from Opportunities to Projects</b> for a better handover after contract award</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Share Documents between Opportunities</b> and create bid-document libraries for mix-and-match bid packs</li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            More Included Documents functionality is on its way!</li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Removed a bug which could prevent Serial Numbers with Reference Documents from saving
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 51 Beta (2022/01/16)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <b>Faster Report Building!</b> New Reports mean you can view and edit your Report Sections and Report Content in the same place
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Baseline Tracking Reports can now be created in Projects that don’t have a defined Product Tree
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            System emails have been upgraded to avoid hungry spam filters
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Bigger, better checkboxes for Reports and Deliveries - now more clickable!
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 50 Beta (2021/11/01)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            GNC Go gets a fresh new look
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Celebrating 50 releases packed full of your fantastic feedback and feature requests. This is for you - we hope you like it!
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 49 Beta (2021/10/04)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Owner field is now mandatory for QA Documents, QA Records and Business Records, and defaults to the current User
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 48 Beta (2021/08/08)</h3>
                                    <ul className="unstyled changelog">
                                        
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Open buttons in document Filepath areas. Thanks for your feedback!
                                        </li>
                                        
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Click a Filepath to Copy to Clipboard. Thanks for your feedback!
                                        </li>
                                        
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Owner field is now mandatory for all Project Documents and Records, and defaults to the current User
                                        </li>
                                        
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Owner dropdowns now reflect Project and Business Access permissions (i.e. Owners must have Access).
                                            Applies to new documents and versions only - existing Owners remain unchanged
                                        </li>
                                        
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 47 Beta (2021/04/19)</h3>
                                    <ul className="unstyled changelog">
                                        
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Removed hyperlinks from Added Dates in the main tables, for simplicity and clarity
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! The Meetings filter within Action Items now remembers your selection until you leave the Action Items area 
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! QA Record Types no longer allows duplicate Names 
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug causing upissued and uprevisioned Documents to take the Added Date of the original Document 
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug affecting reallocation of Deleted reference numbers in Documents and Records
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    
                                    <h3>Version 46 Beta (2021/03/29)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Auto-logout is now a little less fierce. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            QA Documents, QA Records, and Business Documents can now be fully deleted
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Dates in the main tables no longer wrap to two rows at lower resolutions
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    
                                    <h3>Version 45 Beta (2021/03/07)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Quick Status Check!</strong> New Status information in the header of all Documents and Records
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Open buttons now appear in the header of all (none-Withdrawn) Documents, Records and Customer Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Main tables no longer show quick-access Open buttons for Withdrawn items
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Notes fields now auto-size to fit their contents
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                
                                
                                    <h3>Version 44 Beta (2021/02/21)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a navigation issue when running two or more GNC Go tabs in the same browser. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Business area multiselect status filters were broken by the last update - now fixed!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug in Type-Code Map archiving
                                        </li>
                                        
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 43 Beta (2021/02/14)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Faster File Access for Business!</strong> New, Open Document buttons for QA Documents, QA Records, and Business Records
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Search... now keeps your search-term while you work in that area. E.g. if you search for 'Report' in Documents, the Documents table will show Reports until you: change the search-term; clear the search-term; or leave Documents altogether
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As Requested! In-Use Type-Code mappings can now be Archived and Restored. Even-more tidy!
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 42 Beta (2021/01/31)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Faster File Access for Projects!</strong> Open your documents directly from the main tables with new quick-access buttons
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Type-Code mappings can now be Archived and Restored. More tidy!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Intranet and Webserver support</strong>. New, Open Document buttons provide one-click access to Issued and Original documents stored at HTTP File Locations. (Project areas only. Coming to Business areas soon...) 
                                        </li>
                                        
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 41 Beta (2021/01/17)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Multiselect Filters</strong> are ... everywhere!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            All of the main data tables now have multiselect filters - so now you can select views for Live AND Reserved Documents; or Action Items from a series of related Meetings; or compare Record Types AND Document Types; and much more
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Dropdown selectors updated and standardised throughout
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Major back-end upgrades and improvements in preparation for upcoming features. More to follow ...
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                    <h3>Version 40 Beta (2020/09/20)</h3>
                                    <ul className="unstyled changelog">
                                        
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Quick Workflow!</strong> Quick-adding New Documents, Records, Users etc. from Home, now returns straight back to Home. Less clicks - more work!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Added full in-application navigation history. E.g. Cancel now takes you back to your last GNC Go page, not the last page your browser visited
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug which could prevent Reports and Deliveries from being deleted after editing
                                        </li>
                                        
                                    </ul>
                                    <div className="hr-line-dashed"></div>
                                    
                                <h3>Version 39 Beta (2020/08/23)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>Serial Numbers</strong> have been improved and upgraded. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        As Requested! Now you can <strong>Add Reference Documents</strong> (e.g. controlling documents and drawings, or inspection records) to Serial Number items
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Serial Number Controllers can now <strong>Delete</strong> Serial Number items
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Serial Numbers can no longer be edited by Read-only Project members
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        The Serial Numbers Project dropdown now only displays Projects you're a member of (Project Admins see all Projects)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Serial Numbers Project dropdown items are disabled for Read-only Project membership
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 38 Beta (2020/07/28)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        The Upissue and Uprevision buttons on Project Documents and QA Documents now take you straight into the new version. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        As Requested! New Projects and Opportunities can now add all Users (Read-only) by default, as a system-level configuration option 
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! SMART Template downloads now indicate when your download is taking place, and when the template is opening in the default application for that filetype. Thanks for your feedback! 
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 37 Beta (2020/07/11)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>Bookmarks support is here!</strong> Now you can create browser Bookmarks for all of your favourite GNC Go pages and projects
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        As Requested! In-Use warning-buttons now show where! Click through the dropdown to view and manage any item
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        We've redefined what In-Use actually means in a number of areas (i.e. what's now included in the In-Use dropdowns)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Security Admin has moved into the User Admin area, accessed through the Manage Security link-button
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Page-information text has been added and improved across GNC Go. More to follow ...
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! User Admin area has new page-header titles and quick-links
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Changes to navigation when you hit various buttons (cancel, save, delete, clone etc.), to support bookmarking and improve workflow 
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Button spacing and appearance tweaked and standardised throughout
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Account | Set up 2FA menu item renamed 2FA Settings
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        As Requested! The (Template) suffix has been removed from autogenerated SMART Template filenames
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        CADM Admin now has full access to QA areas within the CADM Admin menu, regardless of their Business Access permissions
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Once a Report has been saved, its Report Scheme field can't now be changed
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Report Scheme Output checkboxes can't now be changed when the scheme is In-Use
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        User initials are now automatically updated everywhere (within about a minute) when their name (Forename or Surname) is changed
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>


                                <h3>Version 36 Beta (2020/04/14)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Project Members now have full access to the Deliveries module.  Quickly create and manage document delivery lists to keep a formal record of their distribution to customers and suppliers
                                    </li>

                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Changing to an Opportunity from a Project's Reports or Deliveries area (which don't exist in Opportunities) now takes you directly to that Opportunity's Dashboard 
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Quick-links to Projects and Opportunities in the Home page Admin tile now take you directly to the Project Portfolio, and automatically apply the All Projects or All Opportunities view filter
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Added My Projects and My Opportunities views to Project Portfolio
                                    </li>
                                    <li> 
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Home page Recents list now captures New Projects and New Opportunities
                                    </li>
                                    <li> 
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Project Admin and Opportunities Admin can now access any Project / Opportunity, from the Project Portfolio view. Only Dashboard and Information are available unless the Admin wishes to join as a member (Information | User Access)
                                    </li>
                                    <li> 
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! New Project and New Opportunity pages get header quick-links back to the Project Portfolio
                                    </li>
                                    <li> 
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! 'Created' dates are now labeled 'Added' dates in the main tables, to avoid confusion between date of document creation, and date of addition to GNC Go
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Removed a bug which could cause incorrect loading of the Deliveries table
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 35 Beta (2020/04/01)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Upgraded email-delivery technology means that more GNC Go system messages will reach your Inbox (avoiding over-eager spam filters!) 
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Project and Opportunity Admin functionality is now built into the main menu workflow. Add New Projects and Opportunities straight into the Project Portfolio view, Edit details directly within the Information page
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        As requested! More tweaks to the CADM Admin area, with minor changes to the Document Types and Template section headings, titles and associated quick-links
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Patched a bug which could cause a mismatch between the title and content of Project and Opportunity tables when using bookmarks for navigation. Application-wide support for bookmarking is on its way. Thanks for your feedback!
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 34 Beta (2020/03/10)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>Project Portfolio is here!</strong> A new view in the menu bar displaying all Projects and Opportunities, for all Users. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>Dashboard</strong> (previously called Start Page) and Information are now within the Project and Opportunity area of the menu bar
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        Selecting a Project or Opportunity in Project Portfolio takes you to its Dashboard, ready to start work
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>Home page is here!</strong> Bringing a new way to start your most frequent activities. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        The <strong>Recents tile</strong> provides quick-links to your frequently used Projects and Opportunities
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        The <strong>Business and Admin tiles</strong> bring quick-add buttons, and quick-links to all of your menus and tables
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        The <strong>Messages tile</strong> will show you the main features of each new update without needing to dig into the changelog
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Clicking the Project or Opportunity header-title now takes you to its Dashboard instead of Information page
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Scroll-to-top! Navigating to any new page now automatically scrolls your view to the top of that page
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tooltips added to the header and footer areas, and to the menu bar (when in folded mode)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Required-field indicators <label className="form-required-star">*&nbsp;</label> added throughout the Admin and Security areas – required fields are now indicated throughout GNC Go
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        All areas now have page-header titles, reflecting the current menu-item selection. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Clicking any Template name in the CADM Admin Document Types table will now take you straight to that Template item (these were previously only accesible through the Templates page)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Serial Number Added date is now a required field (and still auto-populates with today's date, as before) 
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Document Owner field now clears on up-version if that User's account has been Disabled
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Report Created Date picker now defaults to the current year and month
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Reports page-info text is now visible to all Users, not just CADM Controllers
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        The New Report Type button was disabled by changes in the last update and now works again
                                    </li>
                                </ul>

                                <div className="hr-line-dashed"></div>

                                <h3>Version 33 Beta (2020/01/25)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        Required-field indicators <label className="form-required-star">*&nbsp;</label> added throughout Project, Opportunity, and Business areas. Coming to Admin areas soon. Thanks for your feedback!
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        New link-buttons between Templates, Document Types, QA Document Types and QA Record Types make navigation quicker and easier
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        As requested! SMART Templates are now provided as an optional Download on Save (i.e. after required-field checks)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        SMART Template Download on Save defaults to 'Yes' for first version, then 'No' for subsequent versions - the option to download a SMART Template for later versions allows Templates to be added or updated
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        SMART Templates are now only available from Reserved Status
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        The CADM Admin area has been updated; including changes to titles, descriptions and overall layout
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        We've simplified the labelling of... Standard Documents, Records and Customer Documents; QA Document and Record Types; Type-Codes, and related items across GNC Go - most of which now have the label 'Type' (wherever this is clear in context)
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        In-form information text (appearance and wording) has been added and improved in multiple areas. Lots more to come!
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! File path placeholder text now clears when that field is locked
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 32 Beta (2019/12/16)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        As requested! Owner is now available as a SMART Template Placeholder
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! QA Document Issue Date now clears on Upissue and Uprevision
                                    </li>
                                    <li>
                                        <span><span className="label label-primary">IMPROVED</span></span>
                                        Tweaked! Text in v31 changelog, and copyright notice (2020)
                                    </li>

                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Disabled User names no longer appear in the Project and Opportunity User Access dropdowns, or the Security | 2FA options list. Thanks for your feedback!
                                    </li>

                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Fixed a bug which allowed the creation of blank Deliveries which couldn't be deleted. Thanks for your feedback!
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                <h3>Version 31 Beta (2019/11/30)</h3>
                                <ul className="unstyled changelog">
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        <strong>SMART Templates are here!</strong> Configuration information added directly and automatically into your Microsoft Word (.docx) Templates
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        Add <strong>SMART Template Placeholders</strong> to new or existing Templates to give your Users one-click SMART Templates
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        SMART Template Placeholders can be used in the usual places - including headers, footers and tables - and formatted like any other text
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        Use SMART Templates for all of your Documents and Records across QA, Projects and Opportunities
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        SMART Templates use our own proprietary technology to find SMART Template Placeholders within your Word (.docx) Templates, insert your field information, then remove the Placeholders
                                    </li>
                                    <li>
                                        <span><span className="label label-info">NEW</span></span>
                                        SMART Templates operate entirely at the code level - without using visual basic, macros or other potentially troublesome additions - leaving your SMART Template as a normal Word (.docx) file ready to go
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        Templates can now be opened from within Standard Documents again
                                    </li>
                                    <li>
                                        <span><span className="label label-warning">FIXED</span></span>
                                        The QA Record Type dropdown can now be cleared
                                    </li>
                                </ul>
                                <div className="hr-line-dashed"></div>

                                    <h3>Version 30 Beta (2019/10/05)</h3>
                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Template manager is here!</strong> A brand new way to manage all of your file Templates
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Upload, view and manage all of your file Templates in one place. Use the Template manager to assign a Template to one or more of your standard document types
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            CADM Admin can now manage <strong>QA Document Types and QA Record Types</strong>
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Templates for QA Documents and QA Records are now associated directly with their Type
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Two new CADM Admin menu items allow CADM Admin to create and manage QA Document and QA Record Type Codes and Names, and view associated Templates
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Responsive tables!</strong> Something feels... different? We've sprinkled responsive-dust all over the place, meaning that tables now elegantly auto-size themselves to fit the page as you change zoom levels or resize your window
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Some of the labelling text around Template and Standard Document functionality; for clarity and consistency
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Template files are now uploaded only when you hit Save Changes, meaning that Cancel now cancels properly!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As Requested! Added a Funding Type dropdown to Opportunities
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 29 Beta (2019/08/18)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Disabled accounts.</strong> User Admin can now view and manage either Active or Disabled accounts
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Disabled accounts won't be available as Owners of New items (existing Owners remain until reallocated)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Owner field added to all Document and Record tables
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Guidance information added around File Locations
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Added ISO section to QA Documents table
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! New User Forename and Surname fields are now mandatory
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Two Users can't now up-version the same Document at the same time
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Document field in QA Documents and QA Records hidden while we work on an upgrade - more coming!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Tweaked! Welcome emails won't be sent to the email address of New Users following "The given Email already exists" message
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            New Users now get logged straight in after first setting up their password
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 28 Beta (2019/07/28)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Templates for QA Records and QA Documents!</strong> Now you can add your own Standard Document Templates to all of your QA documents
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                                                                            Download a Template for your new QA Record or QA Document, and the download filename will be automatically set up to match the database (Title and Reference)                                            </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>File Locations are here!</strong> Access the latest Issue of every Document and every Filed Record from your Projects, Opportunities, and Business areas
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Add file paths</strong> or <strong>Add clickable links</strong> to all of your Live (Issued) Documents, and Filed Records
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            For webservers, Add File Locations as clickable links for super-quick access
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            For local network drives, Add File Locations as plain text file paths. To open a file just hit Copy to Clipboard, paste into Explorer and press return
                                        </li>

                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Control the <strong>Issued (Read Only)</strong> file, and the <strong>Original (Editable)</strong> copy of each Document. Make sure you start your next version from the right source
                                        </li>
                                                                                    <li>
                                                                                            <span><span className="label label-info">NEW</span></span> 
                                                                                            Add multiple Original (Editable) files. If, for example, your Issued (Read Only) .pdf was built from an Original (Editable) Word file containing Excel tables which also need to be controlled
                                                                                    </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Tooltips added to the Quick Add buttons, and tooltip appearance changed throughout
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Current Project or Opportunity title is no longer displayed while you're in Security Admin
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Pages linking to Standard Documents and Document Templates now open faster
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 27 Beta (2019/06/23)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Quick Add is here!</strong> Add new items to your Projects and Opportunities directly from the Start page
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As Requested! Your Organisation Code is now pre-populated when you create a New Project, Opportunity or Serial Number
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As Requested! New Projects and New Opportunities now remember your last Configuration Scheme selection 
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Standard Document Template size now limited to 10Mb, for reliable operation over a variety of networks (normally plenty for a template - but let us know if you need more!)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Document Issue Date field has moved down, to be with issue Status. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Setup 2FA menu item appearance and behaviour
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Improved dynamic button-wrapping
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Forgotten password now plays nicely with 2FA
                                        </li>
                                    </ul>
                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 26 Beta (2019/05/19)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Security admin controls are here!</strong> User Admin can now manage individual 2FA options from the new Security admin area
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Required 2FA</strong> ensures an extra level of security is active on a User account
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Optional 2FA</strong> allows Users to Enable or Disable 2FA from their own Account menu
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Reset 2FA</strong> for any user who has lost access to their OTP (one-time passcode) or authenticator app
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            QA Document auto-numbering can now fill-in the gaps where manual (back-end) changes have removed items
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Added 'on hold' to the list of Project Status options. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A number input fields had clear ('x') buttons which didn't do anything. Now they do.
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 25 Beta (2019/04/14)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Two Factor Authentication is here!</strong> Adding another layer of security to your accounts
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            All Users now have the option to enable and use Two Factor Authentication with an authenticator app for mobile devices (such as Google Authenticator or Microsoft Authenticator)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project Statistics tiles are clickable! Creating an alternative way to navigate GNC Go
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Tracking Reports can now be deleted without having to first Delete all Baselines
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Change Password is now outside of Projects and returns to your last page on close
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            All 'Select...' dropdowns now show more items, making it easier to find what you're looking for
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Multi-select dropdown appearance
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Security related upgrades (revoked access)
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 24 Beta (2019/03/23)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            <strong>Log out everywhere.</strong> Logging out anywhere (any device, browser window, or tab) now logs you out everywhere
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Other security related upgrades (Log in, Log out, Forgotten password, Change password)
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug which could lead to certain menu items not being available
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 23 Beta (2019/03/07)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As requested! New power tools to help you manage Users, Projects and Opportunities
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            User Admin can now <strong>Add New Users</strong>, and configure new accounts before the User is invited to sign in
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            User Admin can now <strong>Add All Projects or Opportunities to any User</strong>, at any given access level
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project and Opportunity Admins can now <strong>Add All Users to any Project or Opportunity</strong>, at any given access level
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Minor changes to the New User welcome email
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! 'Username' text replaced with 'Email' in field labels and column headings for consistency
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! New Users now go straight to the Start page after selecting their first Project or Opportunity
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A bug in the Accounts | Profile page could cause a session to hang. Feature disable for now, pending other related updates
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 22 Beta (2019/01/31)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Add Minutes to your Meetings!</strong>
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As requested! Now you can add quick-links to Meeting Minutes, or any other Documents, Records or Customer Documents related to your Meeting
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Meetings tables now have an I/E column so that you can sort for or display only Internal or External Meetings
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 21 Beta (2018/11/01)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Meetings are here!</strong> First introduced in Version 18, Meetings have made it to the main menu and now work even more closely with Actions
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            View and manage all of your Project Meetings from the upgraded Meetings table
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            See <strong>Action Stats</strong> for every Meeting. Click-through to manage Open, Closed or All Actions; by Meeting, or by Project
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Set the default Internal / External setting for new Actions when you create a new Meeting
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            A number of workflow tweaks deepen the integration of Actions and Meetings
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Templates now support longer filenames (up to 255 chars)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Standard Documents have a new Delete Template function
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            The Template filename in Documents | Available for Download now takes on the reference & title of the Document
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            A new look for the Start page tiles. (More on the Start page soon!)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Action Status icons have been swapped-out for text, to avoid confusion
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Tweaked! Filter-dropdowns were cutting off descenders in certain browsers. Thanks for reporting!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 20 Beta (2018/10/20)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Templates are here!</strong> Add Templates to each of your Standard Documents and view the full list in CADM Admin
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Hit the <strong>Download Template</strong> button when you create a New Document. Your filename will be all set up with Document Reference and Title
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Super Admin!</strong> Can go... anywhere; do... anything. Access all areas with maximum permissions
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            A new layout for the CADM Admin area brings descriptions for each item
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Customer Documents no longer appear in the Reference Structure builder
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked! Documents can no longer be Withdrawn before first Save
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 19 Beta (2018/10/08)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Status-change bug fixed (Projects, Opportunities and Deliveries). Thanks for reporting!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 18 Beta (2018/09/30)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Action Items are here!</strong> This all-new module for Projects and Opportunities brings formal Action Item management to your whole team
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Use the search-filter to quickly sift through or create custom views. View the whole <strong>Action Item Register</strong> or manage individual actions. Control which actions are reviewed within your team, and which to share with external partners
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            No need to keep updating Due dates! Instead of a fixed date you can also use an event or milestone (e.g. KO)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            AI permissions currently follow the User Access level for each Project or Opportunity (although Members have full AI edit and status-change rights)
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Use <strong>Meetings</strong> to group and manage your Action Items and to control which you display on screen during meetings and reviews
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Reports are now simpler to use with a number of interface and workflow tweaks. Thanks for your great feedback!...
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've replaced the New Report button with New Tracking Report and New Status Report buttons, adding guidance text for each
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            New Reports are now headed Tracking Report or Status Report and offer only the relevant options in the Report Scheme dropdown
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Report Schemes table (CADM Admin) now displays the Output type for each Scheme
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            A rapid multi-click on Upissue or Uprevision buttons can no longer create unwanted new versions
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Start page is a little prettier with new tile colours, and Project statistics now update instantly
                                        </li>
                                        {/*
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As Requested! QA Document and Opportunity Document references now include Type, and their sequencial numbers are now Type-specific
                                            </li>
                                          */}
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 17 Beta (2018/08/28)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Export to MS Word!</strong> Hit the new <strong>Word button</strong> on any Tracking Report Baseline to create a fully-editable MS Word (docx) Report
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            The Tracking Report viewer (View button) now has a cleaner layout, displays more Baselines, and includes Report details
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Removed a back-end bug on Baseline Save and Delete operations
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            New Baseline User feedback messages now clear-off when they've done their job
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 16 Beta (2018/07/29)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Just a tweak! All Clone buttons now have Spinners (matching the Save buttons)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Adjusted default Clone button action to Save-then-Clone
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Removed a bug which could prevent saving changes in Type-Code Maps
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            More Reports functionality is on its way. <strong>Export to MS Word</strong> coming soon...
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 15 Beta (2018/07/01)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Baselines</strong> are here! Snapshot your configuration baseline at key milestones, gateways and reviews
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            View and compare changes between Baselines with new <strong>Tracking Reports</strong>. Tracking Reports focus solely on the Live and Filed items that make up your configuration baseline
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Your previous configuration status reports have a new name ... <strong>Status Reports!</strong> Status Reports still show any-and-all of your Documents and Records, regardless of their filing status
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Assign Report Schemes to output either Tracking Reports or Status Reports
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 14 Beta (2018/06/07)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            You reported a reference bug in Serial Numbers. We fixed it. Thanks for your feedback!
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            New Reports functionality is on its way. <strong>Baselines</strong> coming soon...
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 13 Beta (2018/04/19)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>QA Records</strong> are here!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            A whole new QA Records section helps keep all of your User-generated Quality Records organised and under-control
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Manage Access permissions for your QA Records from the Business Access control area within User Admin 
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A New Opportunity now starts with the correct &lt;New Opportunity&gt; text
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 12 Beta (2018/03/29)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As requested! More <strong>Edit</strong> and <strong>Delete</strong> powers for Admins and CADM Controllers
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Edit or Delete Projects and Opportunities if they're not in use
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Delete Documents, from Reserved or Withdrawn status, if they're not in use (in a Report or Delivery) and there are no more-recent versions
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Delete Customer Documents and Records, from Reserved or Withdrawn status, if they're not in use (in a Report or Delivery)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Now you can create a New Project or New Opportunity before you've finalised its Configuration Scheme
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Serial Numbers no longer include Opportunities in the Project dropdown
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've revisited headers and page-text for Projects and Opportunities, making it more obvious when you're in each - and when you're in neither
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! User lists are now presented alphabetically
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! We've extended 'Search boxes now remember your search until you leave a menu area' to the CADM Admin areas
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 11 Beta (2018/02/06)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            A new Opportunity Access control separates Opportunities from Projects in the User Roles and Access controls area
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As requested! Opportunities have a new default Status list
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            As requested! Opportunities get a number of new free-text fields as well as a Bid-Manager dropdown
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! We've added hover-over screen-tips to the Access control tools, giving you more information on each Access level 
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Back-end changes now allow for Projects and Opportunities to have different fields
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Created date column added to the main tables, so you can now arrange your data chronologically
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Various back-end changes in preparation for a move to new servers - and a new name!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>We are GNC Go.</strong>
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 10 Beta (2018/01/23)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Opportunities</strong> are here!
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Manage <strong>Customer Documents, Documents</strong> and <strong>Records</strong> for your Business Development Opportunities; from initial enquiry to Project kickoff
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            The new <strong>Opportunity Admin Role</strong> can manage User Access and Create New Opportunities from the new <strong>Opportunites Admin area</strong>
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Apply Reference Structures and Configuration Schemes to your Opportunities in the same way that you do for full Projects
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Switch between Opportunities and full Projects using the (Change Project) menu
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Search boxes now remember your search until you leave a menu area
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 9 Beta (2017/12/17)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Product Trees</strong> have arrived! More power to your Project
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Manage large or complex Projects with one, two or three distinct <strong>Systems</strong>, each with its own set of <strong>Models</strong>
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Documents, Records and Customer Documents can now be assigned to individual Models, whole Systems, or an entire Project
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Add to or modify your <strong>Product Tree</strong> on Live Projects, as the scope of work evolves
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Quickly run <strong>Reports by Product Tree</strong> item; at Model, System or Project level
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 8 Beta (2017/09/31)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Making a Document Live and creating an Upissue or Uprevision is now a two-step process
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Upissue and Uprevision buttons don't now Save Changes to the current Document
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! Can now only Upissue and Uprevision a Live Document
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Status-based field-locking was applied as soon as you selected a new Status. This is now applied only when you Save Changes
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Edit Document Delivery List now remembers its last Status filter settings
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            The Reports table now has a Status column
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked data validation for New Serial Numbers
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've tidied up error messages for duplicate entries across the application
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Following on from the 'User Roles and Admin Controls' update, we've tidied up the various 'no access' messages across the application
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Owner is now a mandatory field for Filed status on Records and Business Records
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Project Admin now has two different Project lists, reflecting their dual roles as Project Member and Project Admin. (Change Project) displays only Projects they're a member of, whereas Admin | Projects contains all Projects
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Removed a bug where the User needed to press the Log in button twice
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            A rapid double-click on the Save button can no longer create a duplicate Document entry
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            It's no longer possible to create a Live Document with no Date by changing Status to Live and clicking Upissue in a single step
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 7 Beta (2017/09/24)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>User Roles and Admin Controls!</strong> Add multiple Members to a Project, or multiple Projects to a Member; set Business information access rights and more
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            The new <strong>User Admin</strong> role can set all permissions across the application; assign other Admin rights, access to Business information areas, and manage Project access with three new membership types
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Assign <strong>Read-only</strong> access to Projects or any (non-Admin) area to involve a wider team
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project <strong>Members</strong> can create, view and edit Project items
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Project-specific <strong>CADM Controllers</strong> run all day-to-day configuration activities to keep the team on track
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Dedicated menu items for User Admin, Project Admin and CADM Admin bring your tools together
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Serial Numbers, QA Documents and Business Records all get their own <strong>four-level access control</strong>
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Project Admin</strong> can create and edit Projects, add Members and define membership types
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Tweaked the password reset flow to avoid a 'please try again later' delay
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 6 Beta (2017/08/31)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Reports</strong> are here! Set up standard Report Schemes, then create custom Reports in seconds. Save your Reports for reference, edit Report contents, or copy-paste into your own Word, Excel and Powerpoint documents
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Forgotten your password?</strong> No problem, now you can request a secure-reset email from the sign in screen
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Multi-select filters were feeling blue; now they're green
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 5 Beta (2017/08/20)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As-requested! In cases of duplication errors, duplicate entries are now highlighted to the user
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Non-Admin users can now add (Reserved) QA Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Added a filter on Configured Item type to relevant tables
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Column sorting and filters now remember your previous settings
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaked data-validation and Date-population on Records and Business Records
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've made some usability tweaks to Type-Code Maps, including support for Type-Code List changes
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Field-locking tweaks for Documents and QA Document Superseded status
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Improved error checking and messages (mainly relates to Safari browser)
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a bug which could prevent deletion of duplicate Standard Documents
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 4 Beta (2017/08/01)</h3>

                                    <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Further requested changes to QA Document numbering
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Most lists and dropdowns are now presented in a-z order by default
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Improved data-validation and user-information messages on Type-Code Lists (removing a possible endless-save error)
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Document Issue Date and Custom fields now clear for new Documents
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            When new Standard Documents were added to an existing Configuration Scheme (through a Type-Code Map) a caching glitch could prevent these from being available to new Documents. This is now fixed and changes reach all users within ~60 seconds
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Type-Code Maps now sort correctly on save!
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 3 Beta (2017/07/24)</h3>

                                        <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            As requested! We've changed QA Document fields and Reference Structure
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Document Issue Date and Custom fields now clear on Upissue and Uprevision
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Tweaks to interface and appearance throughout
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            User information form is now read-only for normal users
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Number From field for Type-Code Lists is now mandatory (and auto-populates)
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Document Titles are now editable in Reserved status
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Standard Document Maps are now called Type-Code Maps to avoid confusion with new features in the pipeline
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            This release contains (currently hidden) elements of a major new feature. Reports are coming soon!
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Squashed a bug preventing changes to Project attributes on save
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 2 Beta (2017/06/18)</h3>

                                        <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Delivery History</strong> on every Document now shows you which Deliveries the Document was included in
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            This <strong>Changelog</strong> will keep you up to date on new features and improvements
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            A new 'Select All / Select All Search Results' feature on the Bulk-add tool for Document Maps helps you build up maps more quickly
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Spinners on Save buttons show that things are happening in case of any network lag
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            We've rearranged the Bulk-add tool for Document Maps to improve flow
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            User Position has been removed from both the User Information and Home screens as team members may have different roles or positions on different Projects
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Document Schemes have been renamed Configuration Schemes reflecting their use across other types of configured items including Customer Documents and Records
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Element Code is no longer a mandatory field and can be left blank if it's not applicable
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Greyed-out Status indicators are now more distinguishable from active (clickable) ones
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Project Codes can now be up to 6 characters long
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Document Maps and Type-Code Lists now auto-sort (a-z) when they're saved
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Improvements to login and security, including a 'Remember me' login option
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Customer Document configuration simplified, removing Reference Structures and bringing version information into the Reference field
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Customer Documents with different version information were wrongly prevented from saving
                                        </li>
                                    </ul>

                                    <div className="hr-line-dashed"></div>

                                    <h3>Version 1 Beta (2017/06/01)</h3>

                                        <ul className="unstyled changelog">
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            <strong>Deliveries</strong> helps you build document delivery lists for datapacks and ad-hoc transmittals, track delivery and receipt status, and view all previous deliveries
                                        </li>
                                        <li>
                                            <span><span className="label label-info">NEW</span></span>
                                            Two new custom-fields added to Documents provide some requested flexibility 
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            System hits first Beta-level release
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Now remembers your last project when you next log in
                                        </li>
                                        <li>
                                            <span><span className="label label-primary">IMPROVED</span></span>
                                            Back-end improvements to history logging in preparation for future features 
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Fixed a glitch in Document Maps where removing then adding back the same Standard Document & Type-code combination refused to save
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Changed the locking and table-clearing logic for the Document Map Configured Item and Type-code List dropdowns
                                        </li>
                                        <li>
                                            <span><span className="label label-warning">FIXED</span></span>
                                            Squashed a bug in Document Maps where the in-use label didn't always display correctly for Records
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Changelog
